import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLOGIN, baseUrl, browserName, browserVersion, language } from "../../Tools/APIs";
import { Col, Container, Row } from "../../Tools/Grid-system";
import { ButtonMain, Cards, Input } from "../../components";
import { content } from "../../Context/translate";
import female from "../../images/female.svg";
import male from "../../images/male.svg";
import { useContextHook } from "../../Context/ContextOPen";
import Loading from "../../Tools/Loading";
import { toast } from "sonner";
import axios from "axios";


function SimpleSignUp() {
    const navigate = useNavigate();
    const { setListError } = useContextHook();
    const { handleSubmit, loading, handleChange, formData, setFormData, error } = useLOGIN({});
    const [agreed, setAgreed] = useState(false);
    const [gender, setGender] = useState(null);

    // States for email validation
    const [emailError, setEmailError] = useState(null);
    const [typingTimeout, setTypingTimeout] = useState(null);

    // Auto-generate username from email (handled in backend)

    // Validation function for email
   const validateField = (field, value) => {
    if (typingTimeout) clearTimeout(typingTimeout);

    if (!value) {
        setEmailError(null);
        return;
    }

    const newTimeout = setTimeout(() => {
        const dataToSend = {
            [field]: value,
            finger_print: `${browserName} ${browserVersion}` 
        };

        axios.post(`${baseUrl}v1/register/validate`, dataToSend, {
            headers: {
              'locale': language,
            }
        })
        .then(() => setEmailError(null))
        .catch((err) => {
            const message = err.response?.data?.message || "خطأ في التحقق من الإيميل";
            setEmailError(message);
        });
    }, 1000);

    setTypingTimeout(newTimeout);
};


    const handleEmailChange = (e) => {
        handleChange(e);
        validateField('email', e.target.value);
    };

    const handleSubmitFinal = (e) => {
        e.preventDefault();

        if (!agreed) {
            setListError([content.Oath]);
            return;
        }
        if (!gender) {
            setListError([content.SelectGender]);
            return;
        }
        if (emailError) {
            setListError([emailError]);
            return;
        }
        if (formData.password !== formData.password_confirmation) {
            setListError(["كلمة المرور وتأكيد كلمة المرور غير متطابقتين"]);
            return;
        }

        const dataToSend = {
            email: formData.email,
            password: formData.password,
            password_confirmation: formData.password_confirmation,
            gender: gender,
        };



        handleSubmit("v1/simple-register", dataToSend); 
    };


    return (
        <Container className="mb-12 mt-12">
            {loading && <Loading />}
            <Row>
                <Col md={8} className="mx-auto">
                    <Cards className="mt-10 shadow-md">
                        <Col lg={9} md={10} className="mx-auto my-6">
                            <h1 className="text-3xl font-bold text-Main text-center mb-6">{content.CreateAnAccount}</h1>

                            {/* Gender Selection */}
                            <div className="flex justify-center gap-4 my-6">
                                <div onClick={() => setGender("MALE")} className={`cursor-pointer p-4 border-2 rounded-xl transition-all ${gender === 'MALE' ? 'border-Fifth bg-blue-100 ring-2 ring-Fifth' : 'border-gray-300'}`}>
                                    <img src={male} alt="Male" className="w-24 h-24" />
                                    <p className="text-center font-bold mt-2 text-Fifth">{content.RegisterAsaSpouse}</p>
                                </div>
                                <div onClick={() => setGender("FEMALE")} className={`cursor-pointer p-4 border-2 rounded-xl transition-all ${gender === 'FEMALE' ? 'border-Forth bg-pink-100 ring-2 ring-Forth' : 'border-gray-300'}`}>
                                    <img src={female} alt="Female" className="w-24 h-24" />
                                    <p className="text-center font-bold mt-2 text-Forth">{content.RegistrationAsAwife}</p>
                                </div>
                            </div>

                            <Input
                                text={content.Email}
                                title={content.Email}
                                name="email"
                                onChange={handleEmailChange}
                                SignIn={true}
                                containerClass="my-4"
                            />
                            {emailError && <div className="text-red-500 text-sm mt-1">{emailError}</div>}

                            <Input
                                text={content.Password}
                                title={content.Password}
                                name="password"
                                onChange={handleChange}
                                isPassword={true}
                                SignIn={true}
                                containerClass="my-4"
                            />

                            <Input
                                text={content.ConfirmPassword}
                                title={content.ConfirmPassword}
                                name="password_confirmation"
                                onChange={handleChange}
                                isPassword={true}
                                SignIn={true}
                                containerClass="my-4"
                            />

                            {/* Agreement Checkbox */}
                            <div className="my-5 flex items-center justify-start border-Secondary bg-gray-100 border rounded-lg p-3">
                                <input
                                    type="checkbox"
                                    checked={agreed}
                                    onChange={() => setAgreed(!agreed)}
                                    className="mx-3 w-5 h-5"
                                />
                                <span className="text-Main text-base font-bold">{content.IHaveTaken}</span>
                            </div>

                            <div className="flex justify-center">
                                <ButtonMain
                                    onClick={handleSubmitFinal}
                                    title={content.SignUp}
                                    className="w-1/2 mt-6"
                                />
                            </div>
                            {error && <div className="text-red-500 text-center font-semibold mt-4">{error}</div>}
                        </Col>
                    </Cards>
                </Col>
            </Row>
        </Container>
    );
}

export default SimpleSignUp;